import { Line } from 'vue-chartjs'
import { hexToRGB } from "./utils";

const chartColor = "#FFFFFF";
const gradientChartOptionsConfiguration = {
  maintainAspectRatio: false,
  legend: {
    display: false
  },
  tooltips: {
    bodySpacing: 4,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
    xPadding: 10,
    yPadding: 10,
    caretPadding: 10
  },
  responsive: 1,
  scales: {
    yAxes: [{
      display: 0,
      ticks: {
        display: false
      },
      gridLines: {
        zeroLineColor: "transparent",
        drawTicks: false,
        display: false,
        drawBorder: false
      }
    }],
    xAxes: [{
      display: 0,
      ticks: {
        display: false
      },
      gridLines: {
        zeroLineColor: "transparent",
        drawTicks: false,
        display: false,
        drawBorder: false
      }
    }]
  },
  layout: {
    padding: {
      left: 15, 'inset-inline-end': 15, top: 25, bottom: 25
    }
  }
};

export default {
  name: 'line-chart',
  extends: Line,
  props: ['labels', 'datasets', 'color', 'extraOptions', 'title'],
  data: () => ({
    gradientFill: null,
  }),
  mounted () {
    let that = this
    let fallBackColor = '#f96332';
    let color = this.color || fallBackColor;
    const ctx = document.getElementById(this.chartId).getContext('2d');
    const gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
    gradientStroke.addColorStop(0, color);
    gradientStroke.addColorStop(1, chartColor);

    this.gradientFill = ctx.createLinearGradient(0, 170, 0, 50);
    this.gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
    this.gradientFill.addColorStop(1, hexToRGB(color, 0.4));

    let datasets = this.datasets ? this.datasets : [{
      label: this.title || '',
      borderColor: color,
      pointBorderColor: "#FFF",
      pointBackgroundColor: color,
      pointBorderWidth: 2,
      pointHoverRadius: 4,
      pointHoverBorderWidth: 1,
      pointRadius: 4,
      fill: true,
      backgroundColor: this.gradientFill,
      borderWidth: 2,
      data: this.data || []
    }]

    datasets.forEach(function (data) {
      data.backgroundColor = that.gradientFill
    })
    this.renderLineChart(datasets)
  },
  methods: {
    renderLineChart (datasets) {
      let that = this
      let chartOptions = Object.assign(gradientChartOptionsConfiguration, this.extraOptions || {})
      datasets.forEach(function (data) {
        data.backgroundColor = that.gradientFill
      })

      this.renderChart({
        labels: this.labels || [],
        datasets: datasets
      }, chartOptions);
    }
  },
  watch: {
    datasets: function () {
      this.renderLineChart(this.datasets);
    }
  }
}
